export type BackgroundRemovalProgress = {
    phase: 'model' | 'process';
    key: string;
    current: number;
    total: number;
};

export type RemoveBackgroundOptions = {
    onProgress?: (progress: BackgroundRemovalProgress) => void;
};

function assertWebAssembly(): void {
    if (typeof WebAssembly === 'undefined') {
        throw new Error('WEBASSEMBLY_UNSUPPORTED');
    }
}

/**
 * Lazy-load @imgly/background-removal and remove the background from an image file.
 */
export async function removeImageBackground(
    file: File,
    options: RemoveBackgroundOptions = {},
): Promise<Blob> {
    assertWebAssembly();

    const { removeBackground } = await import('@imgly/background-removal');

    const objectUrl = URL.createObjectURL(file);

    try {
        const blob = await removeBackground(objectUrl, {
            progress: (key: string, current: number, total: number) => {
                const phase: BackgroundRemovalProgress['phase'] =
                    key.toLowerCase().includes('fetch') ||
                    key.toLowerCase().includes('download')
                        ? 'model'
                        : 'process';

                options.onProgress?.({
                    phase,
                    key,
                    current,
                    total,
                });
            },
        });

        return blob;
    } finally {
        URL.revokeObjectURL(objectUrl);
    }
}

export function isWebAssemblySupported(): boolean {
    return typeof WebAssembly !== 'undefined';
}
